import axios from 'axios';

export function getTickets(){
    return new Promise((resolve, reject) => {
        axios.get('/web/orders')
            .then(response => {
                const tickets = [];
                //Adding status attribute and its classes
                response.data.forEach(ticket => {
                    if(ticket.current_status == "pending") {
                        ticket.status = "Por asignar"; ticket.statusId = 0;
                        ticket.dropdownMenu = "pendingDropdown";
                        ticket.deliveryman_name = "-";
                    }
                    else if( ticket.current_status == "assigned" ) {
                        ticket.status = "Asignado"; ticket.statusId = 1;
                        ticket.dropdownMenu = "assignedDropdown";
                    }
                    else if( ticket.current_status == "collecting" ) {
                        ticket.status = "Recolectando"; ticket.statusId = 2;
                        ticket.dropdownMenu = "collectingDropdown";
                    }
                    else if( ticket.current_status == "collected") {
                        ticket.status = "En camino"; ticket.statusId = 3;
                        ticket.dropdownMenu = "collectedDropdown";
                    }
                    else if(ticket.current_status == "delivered") {
                        ticket.status = "Entregado"; ticket.statusId = 5;    
                        ticket.dropdownMenu = "deliveredDropdown";     
                    } else {
                        ticket.status = "Cancelado"; ticket.statusId = -1;
                        if(!ticket.deliveryman_name) {
                            ticket.deliveryman_name = "-";
                        }
                    }
                //To join street and district for table´s address
                if(ticket.customer) {
                    ticket.customer.address.streetDistrict = ticket.customer.address.street +  (ticket.customer.address.district ? ", " + ticket.customer.address.district : "");
                }

                //Ticket currency formats
                ticket.subtotal = ticket.subtotal?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});
                ticket.tax = ticket.tax?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});
                ticket.total = ticket.total?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});

                //Ticket date format to get just the date
                var date = ticket.created_at.split("T");
                ticket.created_at = date[0];
    
                tickets.push(ticket);
                })

                resolve(tickets);
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function cancelTicket(number) { 
    return new Promise((resolve, reject) => {
        axios.post('/web/orders/' + number + '/cancel')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    })
}

export default {
    getTickets,
    cancelTicket
}